import { render, staticRenderFns } from "./RegisterPhoneModal.vue?vue&type=template&id=0e84a711&scoped=true&"
import script from "./RegisterPhoneModal.vue?vue&type=script&lang=js&"
export * from "./RegisterPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPhoneModal.vue?vue&type=style&index=0&id=0e84a711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84a711",
  null
  
)

export default component.exports